export default __webpack_public_path__ + "static/media/special-deep-draw.ed372d7f.png";